import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
} from 'chart.js';
import 'chartjs-adapter-date-fns';
import { ComponentProps, memo } from 'react';

import LineChartImpl from './LineChartImpl';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
);

type LineChartImplProps = ComponentProps<typeof LineChartImpl>;
const areEqual = (prevProps: LineChartImplProps, nextProps: LineChartImplProps) =>
  JSON.stringify(prevProps.data) === JSON.stringify(nextProps.data) &&
  prevProps.chartType === nextProps.chartType;

// eslint-disable-next-line react-refresh/only-export-components
export default memo(LineChartImpl, areEqual);
